import { User } from "../user/user.model";

export enum AssignationStatus {
    Open = 'Open',
    Completed = 'Completed',
    Expired = 'Expired',
    Revoked = 'Revoked'
}

export interface LeadAssignation {
    assignor: User,
    assignee: User,

    status: AssignationStatus,

    deadline: Date,
    created: Date,
    updated: Date
}